import axios from 'axios';
import { formatDossierContact, parseDossierContact, parseDossierContacts } from '@/contact/converters/dossierContactConverters';
import ContactData from '@/contact/models/ContactData';
import DossierContact, { DossierContactId } from '@/contact/models/DossierContact';
import { parseDmsSyncStatus } from '@/general/converters/dmsConverters';
import DmsSyncStatus from '@/shared/models/DmsSyncStatus';
import { present } from '@/shared/utils/typescript';
import { DossierId } from '../models/AbstractDossier';

class DossierContactClient {
  async loadByDossierId(dossierId: DossierId): Promise<Array<DossierContact>> {
    const response = await axios.get(`/api/mobopro/v1/dossiers/${dossierId}/contacts`);
    return parseDossierContacts(response.data, dossierId);
  }

  async create(data: ContactData, dossierId: DossierId): Promise<DossierContact> {
    const response = await axios.post(`/api/mobopro/v1/dossiers/${dossierId}/contacts/`, formatDossierContact(data));
    return present(parseDossierContact(response.data, dossierId));
  }

  async update(contactId: DossierContactId, data: ContactData, dossierId: DossierId): Promise<DossierContact> {
    const response = await axios.put(`/api/mobopro/v1/dossiers/${dossierId}/contacts/${contactId}`, formatDossierContact(data));
    return present(parseDossierContact(response.data, dossierId));
  }

  async remove(id: DossierContactId, dossierId: DossierId): Promise<void> {
    await axios.delete(`/api/mobopro/v1/dossiers/${dossierId}/contacts/${id}`);
  }

  async dmsSync(id: DossierId): Promise<DmsSyncStatus> {
    const response = await axios.get(`/api/mobopro/v1/dossiers/${id}/dmscontacts`);
    return present(parseDmsSyncStatus(response.data));
  }
}

export default new DossierContactClient();
